import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip, Button, Form } from 'react-bootstrap'
import { getOrderData, getOrderSortdata } from '../../seller-apis/apidataField';
import api from '../../seller-apis/api';
import '../../assets/css/payment.css'
import PaymentCard from '../common/PaymentCard'
import { useAlert } from 'react-alert';
import moment from 'moment';
import MainLoader from '../common/Loader/PageLoader';

var allscrollLen = 0;
var globalFilter = {
    "pageNo": 1,
    //SL-907
    sortFilter: {
        orderPlaceDate: -1
    }
};
const Transactions = () => {
    var outerdiv;
    var loaderDiv;
    const alert = useAlert();
    // Web states
    const [allRecords, setallRecords] = useState();
    const [ledgerData, setledgerData] = useState([]);
    const [summaryData, setSummaryData] = useState({});

    // Dates
    const [datefrom, setdatefrom] = useState(moment().subtract(30, 'days').format('YYYY-MM-DD'));
    const [dateto, setdateto] = useState(moment().format('YYYY-MM-DD'));
    const [isDateValid, setisDateValid] = useState(false)

    // Loader 
    const [ennewloader, setennewloader] = useState("block");

    // Pagination related
    const [compforPaginationweb, setcompforPaginationweb] = useState("allData");


    // Scroll related events
    const [isallcrollBtnVis, setisallcrollBtnVis] = useState("none");
    const [loadText, setloadText] = useState("Load More")

    // Filter related states

    const [orderId, setOrderId] = useState("")

    // Sorting related states
    const [currstatussort, setcurrstatussort] = useState("Status*")

    const [removeFilterClass, setremoveFilterClass] = useState("invent_remove_filter_btn")

    useEffect(() => {
        allscrollLen = 1;
        dateSortFun();
        // let data = {
        //     "pageNo": 1
        // }
        // api.vendorledger.ledgerData(getOrderData(data)).then((res) => {
        //     console.log(res)
        //     setledgerData(res.data)
        //     setallRecords(res.totalRecords)
        //     setennewloader("none")
        // }).catch(err => console.log(err))


        // Summary data

        // api.vendorledger.ledgersummary(getOrderData(data)).then((res) => {
        //     setSummaryData(res.data)
        //     console.log(res.data)
        // }).catch(err => console.log(err))
    }, [])



    //   Generate excel sheet


    const exportToSheet = () => {
        let btn = document.getElementById("export_Btn");
        btn.innerHTML = `Generating Sheet<span id="dot1"><i class="bi bi-dot"></i></span><span id="dot2"><i class="bi bi-dot"></i></span><span id="dot3"><i class="bi bi-dot"></i></span>`
        api.vendorledger.exportToSheet(getOrderSortdata(globalFilter)).then((res) => {
            btn.innerHTML = `Export to Sheet <i class="bi bi-file-earmark-spreadsheet"></i>`;
            const url = window.URL.createObjectURL(res.data);
            var link = document.createElement("a");
            link.href = url;
            link.download = datefrom === undefined || datefrom === "" ? "Transactions" : "Transactions" + datefrom;
            link.click();
        }).catch(err => console.log(err))

    }


    // Date sorting

    const dateSortFun = () => {
        if (datefrom === "" || datefrom === undefined || dateto === "" || dateto === undefined) {
            alert.info("Please select a date range")
        }
        else {
            let fromDate = new Date(datefrom)
            let toDate = new Date(dateto);
            let diffDate = toDate.getTime() - fromDate.getTime()
            let daydiffer = 1;
            daydiffer += diffDate / (1000 * 60 * 60 * 24);
            daydiffer = Math.floor(daydiffer)
            console.log(daydiffer)
            if (daydiffer > 31) {
                setisDateValid(false)
                alert.info('Date range cannot be more than 1 month.', { position: 'top center' })
                // alert.info("")
            }
            else if (daydiffer < 0) {
                setisDateValid(false)
                alert.info("Please select a valid date range.")
            }
            else {
                setisDateValid(true)
                applyLoader()
                globalFilter.pageNo = 1
                globalFilter.filters = {
                    ...globalFilter.filters,
                    "from-orderPlaceDate": datefrom + 'T00:00:00',
                    "to-orderPlaceDate": dateto + 'T23:59:59'
                }
                setremoveFilterClass("invent_remove_filter_btn_active")
                api.vendorledger.ledgerData(getOrderSortdata(globalFilter)).then((res) => {
                    allscrollLen = 1;
                    setcompforPaginationweb("dateSort")
                    // console.log(res)
                    setledgerData(res.data)
                    setallRecords(res.totalRecords)
                    removeLoader()
                    api.vendorledger.ledgersummary(getOrderSortdata(globalFilter)).then((res) => {
                        setSummaryData(res.data)
                    }).catch(err => console.log(err))
                }).catch(err => console.log(err))
            }
        }
    }



    // Sort according to status

    function statussort(e) {
        applyLoader()
        setcurrstatussort(e.value)
        allscrollLen = 1
        globalFilter.pageNo = allscrollLen
        globalFilter.filters = {
            ...globalFilter.filters, "status": e.value
        }
        api.vendorledger.ledgerData(getOrderSortdata(globalFilter)).then((res) => {
            setloadText("Load more")
            setledgerData(res.data)
            setallRecords(res.totalRecords)
            setremoveFilterClass("invent_remove_filter_btn_active")
            if (res.totalRecords < 1) {
                alert.info("No Records Found")
            }
            api.vendorledger.ledgersummary(getOrderSortdata(globalFilter)).then((res) => {
                setSummaryData(res.data)
            }).catch(err => console.log(err))
            setcompforPaginationweb("statussort")
            removeLoader()
        }).catch(err => console.log(err))
    }


    // Clear Filter

    const clearFilter = () => {
        setisDateValid(false)
        setdatefrom("")
        setdateto("")
        setOrderId("")
        setcurrstatussort("Status*")
        setremoveFilterClass("invent_remove_filter_btn")
        if (globalFilter.filters) {
            globalFilter = {
                "pageNo": 1
            }
            applyLoader()
            allscrollLen = 1;
            let data = {
                "pageNo": 1
            }
            api.vendorledger.ledgerData(getOrderData(data)).then((res) => {
                console.log(res)
                setledgerData(res.data)
                setallRecords(res.totalRecords)
                setcompforPaginationweb("allData")
                removeLoader()
                api.vendorledger.ledgersummary(getOrderData(data)).then((res) => {
                    setSummaryData(res.data)
                }).catch(err => console.log(err))
            }).catch(err => console.log(err))
        }
    }



    // load more 

    function loadMore() {
        if (loadText !== "Loading...") {
            setloadText("Loading...")
            allscrollLen = allscrollLen + 1;
            globalFilter.pageNo = allscrollLen
            api.vendorledger.ledgerData(getOrderSortdata(globalFilter)).then((res) => {
                setloadText("Load more")
                setledgerData(ledgerData => ledgerData.concat(res.data))
            }).catch(err => console.log(err))
        }
    }


    // Scroll function



    function handleScroll() {
        if (window.scrollY < window.outerHeight) {
            setisallcrollBtnVis("none")
        }
        else {
            setisallcrollBtnVis("block")

        }
    }


    // check event

    function checkevent(e) {
        if (e.keyCode === 13) {
            if (orderId !== "") {
                globalFilter.pageNo = 1
                allscrollLen = 1
                if (!globalFilter.orderId) {
                    globalFilter.filters = { ...globalFilter.filters, "orderId": orderId }
                }
                applyLoader()
                setremoveFilterClass("invent_remove_filter_btn_active")
                api.vendorledger.ledgerData(getOrderSortdata(globalFilter)).then(res => {
                    console.log(res)
                    setledgerData(res.data)
                    setallRecords(res.totalRecords)
                    removeLoader()
                    setcompforPaginationweb("orderId")
                    if (res.totalRecords < 1) {
                        alert.info("No records found")
                    }
                    api.vendorledger.ledgersummary(getOrderSortdata(globalFilter)).then((res) => {
                        setSummaryData(res.data)
                    }).catch(err => console.log(err))
                }).catch(err => {
                    console.log(err)
                    alert.error("Unable to search at this time")
                    removeLoader()
                    setcompforPaginationweb("orderId")
                })

            }
            else if (orderId === "" && compforPaginationweb === "orderId") {
                setcompforPaginationweb("allData")
                setremoveFilterClass("invent_remove_filter_btn")
                applyLoader()
                globalFilter = {
                    "pageNo": 1
                }
                allscrollLen = 1;
                let data = {
                    "pageNo": 1
                }
                api.vendorledger.ledgerData(getOrderData(data)).then((res) => {
                    removeLoader()
                    setledgerData(res.data)
                    setallRecords(res.totalRecords)
                }).catch(err => console.log(err))
            }
        }
    }

    window.addEventListener('scroll', handleScroll)


    // apply loaders

    function applyLoader() {
        outerdiv = document.getElementById("payment_tab");
        loaderDiv = document.getElementById("enNewLoader");
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        outerdiv.classList.add("div-bk");
    }

    // remove loader

    function removeLoader() {
        loaderDiv.classList.remove("loader-bt");
        setennewloader("none")
        outerdiv.classList.remove("div-bk");
    }

    return (

        <div id="orDeskContain" className='mb-4'>


            {/* New orders desktop */}
            <div className="tab">
          
               
                <div className="contain_payment_table mx-2">
                         
                    {/* Note container Ticket SL-665 Author - Ankit nigam*/}
                    <div className='m-auto mt-1'>
                        <span style={{ "color": "red", "font-size":"15px", "font-weigh":"600" }}>NOTE: This report was last updated today morning at 5:00 AM, and does not include the latest updated orders.</span>
                    </div>
                    <div className='d-flex mb-3 justify-content-around f-d-column'>
                   

                        {/* Date container */}
                        <div className='theme-shed1 p-2'>
                            <div className='m-auto mt-1'>
                                <span className='payment_dates'>From: - <input type='date' value={datefrom} onChange={(e) => setdatefrom(e.target.value)}></input></span>
                                <span className='mx-2 payment_dates'>To: - <input type='date' value={dateto} onChange={(e) => setdateto(e.target.value)}></input></span>
                                <span><button className='apply-btn px-3 py-1 ff_Pop fs-14' onClick={() => dateSortFun()}>Apply</button></span>
                                {/* <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => clearFilter()}>Clear</button></span> */}
                            </div>
                        </div>
                        <div className='p-1'>
                            <table className='payment_summary_data'>
                                <tbody>
                                    <tr>
                                        <td>Total Orders :- {summaryData && summaryData.totalOrders ? summaryData.totalOrders : 0}</td>
                                        <td>Total Transfer price :- <i class="fa fa-inr" aria-hidden="true"></i> {summaryData && summaryData.totalTransferPrice ? summaryData.totalTransferPrice : 0}</td>
                                        {/* Note container Ticket SL-665 Author - Ankit nigam*/}
                                        <td>
                                            <OverlayTrigger
                                                key="ttf"
                                                placement="top"
                                                overlay={
                                                    <Tooltip id={`tooltip-ttf`} className="fs-14 order_page_tooltip">
                                                        <p className='fs-12 f-500 order_page_tooltip_1'> Include only complete<br/>
                                                         and shipped orders.<br/>RTO Order not added in this.</p>
                                                    </Tooltip>
                                                }
                                                >
                                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                                                </OverlayTrigger>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            {/* <button className='payment_summary_btns me-2'>Total Orders ({summaryData.totalOrders})</button>
                            <button className='payment_summary_btns me-2'>Total Transfer price (<i class="fa fa-inr" aria-hidden="true"></i> {summaryData.totalTransferPrice})</button> */}
                        </div>
                        {/* Export button */}
                        <div className='p-2'>
                            <button className="px-3 py-1 ff_Pop payment_btn_export fs-17" id="export_Btn" onClick={() => exportToSheet()}>Export to Sheet <i class="bi bi-file-earmark-spreadsheet"></i></button>
                        </div>
                    </div>
                    <div className="table-responsive">
                    <table className='payment_table' style={{ "width": "100%" }} id="payment_tab">
                        <thead>
                            <tr className='table_ord_title_row'>

                                <th className='thead_title' style={{ "width": "5%" }}>Date
                                </th>

                                <th className='thead_title pb-1' style={{ "width": "5%" }}>Order Id
                                    <br></br>
                                    <input type="text" value={orderId} name="name" placeholder='Search' className='w-90 order_table_srch_input' onChange={(e) => setOrderId(e.target.value)} onKeyUp={(e) => checkevent(e)} />
                                    <i class="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true"></i>
                                </th>

                                <th className='thead_title' style={{ "width": "7%" }}>Order status
                                    <br></br>
                                    <Form.Select size="lg" className="pro_card_comb_box_invent mb-1" style={{ "width": "90%" }} onChange={(e) => statussort(e.target)} value={currstatussort}>
                                        <option value="Status*" disabled selected>Status*</option>
                                        <option value="complete">Complete</option>
                                        <option value="shipped">Shipped</option>
                                        <option value="cancelled">Cancelled</option>
                                        <option value="RTO">RTO</option>
                                    </Form.Select>
                                    <br></br>
                                </th>

                                <th className='thead_title' style={{ "width": "5%" }}>Transfer price
                                    <br></br>
                                    (incl. gst) <br></br>[A]
                                </th>

                                {/** Platform Fee Ticket : SL-662 */}
                                <th className='thead_title' style={{ "width": "5%" }}>Platform Fee
                                <   br></br>
                                    (incl. gst) <br></br>[I]
                                </th>

                                <th className='thead_title' style={{ "width": "7%" }}>Customer's purchase price
                                    <br></br>
                                    (excl. gst) <br></br>[B]
                                </th>

                                <th className='thead_title' style={{ "width": "5%" }}>Supply of goods
                                    <br></br>
                                    GST %
                                </th>

                                <th className='thead_title' style={{ "width": "5%" }}>Customer's purchase price
                                    <br></br>
                                    (incl. gst)
                                    <br></br>[C]
                                </th>

                                <th className='thead_title' style={{ "width": "5%" }}>Gramstrong commission
                                    <br></br>
                                    (incl.18% gst)
                                </th>
                                <th className='thead_title' style={{ "width": "3%" }}>TDS  <OverlayTrigger

                                    key="tds"
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id={`tooltip-tds`} className="fs-10 order_page_tooltip">
                                            <p className='fs-8 f-500 order_page_tooltip_1'> Till sep'24- 1%
                                            From Oct'24 -0.1% of customer's purchase price(excl. gst).<br></br>
                                                Post deposit of this amount and filing TDS Return by Gramstrong, it will reflect in 26AS of the Supplier</p>
                                        </Tooltip>
                                    }
                                >
                                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                                </OverlayTrigger>
                                    <br></br>
                                    [D]
                                </th>
                                <th className='thead_title' style={{ "width": "3%" }}>TCS(0.5%)  <OverlayTrigger
                                    key="tcs"
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id={`tooltip-tcs`} className="fs-10 order_page_tooltip">
                                            <p className='fs-8 f-500 order_page_tooltip_1'> Till Jan'25 - 1%
                                            From Feb'25 - 0.5% of customer's purchase price(excl. gst).<br></br>
                                                Post Deposit of this amount and return filing by Gramstrong, it will reflect in GSTR-2B of Supplier</p>
                                        </Tooltip>
                                    }
                                >
                                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                                </OverlayTrigger>
                                    <br></br>
                                    [E]
                                </th>
                                <OverlayTrigger
                                    key="tcs"
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id={`tooltip-tcs`} className="fs-10 order_page_tooltip">
                                            <p className='fs-8 f-500 order_page_tooltip_1'>Transfer price - TDS - TCS
                                            </p>
                                        </Tooltip>
                                    }
                                >
                                    <th className='thead_title fw-bolder' style={{ "width": "7%" }}>Amount to be remitted by Gramstrong
                                        <br></br>
                                        [G=A-D-E-I]
                                    </th>
                                </OverlayTrigger>

                                <th className='thead_title' style={{ "width": "7%" }}>Payment Status</th>
                            </tr>

                        </thead>
                        <tbody>
                            {ledgerData.length > 0 ? ledgerData.map((item, index) => {
                                let date = new Date(item.orderDate);
                                let d = date.toUTCString(item.orderDate);
                                let newd = d.substr(4, 12)
                                return (
                                    <PaymentCard id={index}
                                        lead={item._id}
                                        date={newd}
                                        orderId={item.orderId}
                                        orderStatus={item.orderStatus}
                                        transferPriceInclGst={item.transferPriceInclGst}
                                        customerPriceExclGst={item.customerPriceExclGst}
                                        gstPercent={item.gstPercent}
                                        customerPriceInclGst={item.customerPriceInclGst}
                                        tvCommissionExclGst={item.tvCommissionExclGst}
                                        tvCommissionInclGst={item.tvCommissionInclGst}
                                        tds1Percent={item.tds1Percent}
                                        tcs1Percent={item.tcs1Percent}
                                        amountToRemitted={item.amountToRemitted}
                                        razorpayxDetails={item.razorpayxDetails}
                                        from="transactions"
                                        //Platform Fee Ticket : SL-662
                                        platformFee={item?.pfFees}
                                    />
                                )

                            }) : <>

                            </>
                            }
                        </tbody>
                    </table>
                    </div>
                </div>

                <div className="d-flex justify-content-center" id="enNewLoader" >
                    <div style={{ "display": ennewloader }}>
                        <MainLoader/>
                    </div>
                </div>

                {allscrollLen * 15 <= allRecords ? <div className='loadMorecntn d-flex justify-content-center '>
                    <button className='payment_btn_export mt-4' onClick={() => loadMore()}>{loadText}</button>
                </div> : isallcrollBtnVis === "block" ? <><p className="pageendTxt text-center mt-4">Looks like you have reached bottom of the page</p></> : <></>}


                <div className='scrolltoptnCnt' style={{ "display": isallcrollBtnVis }}>
                    <a href='#orDeskContain'>
                        <Button variant="dark"><i class="fa fa-arrow-up" aria-hidden="true"></i></Button>
                    </a>

                </div>



            </div>

        </div>
    )
}

export default Transactions;